import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// ===============================
// YENİ COMPACT CSS SYSTEM
// ===============================


// BOOTSTRAP CSS (Eğer kullanıyorsanız)
import 'bootstrap/dist/css/bootstrap.min.css';

import './styles/main.css';       // Ana stiller (28 KB)
import './styles/components.css'; // Component layout'ları (15 KB)

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
// RegisterPage REMOVED - Admin will create users manually
import VehiclesPage from './pages/VehiclesPage';
import VehicleDetailPage from './pages/VehicleDetailPage';
import AddVehiclePage from './pages/AddVehiclePage';
import EditVehiclePage from './pages/EditVehiclePage';
import ProfilePage from './pages/ProfilePage';
import ProfileEditPage from './pages/ProfileEditPage';
import ApplicationPage from './pages/ApplicationPage';
import AdminImportDataPage from './pages/AdminImportDataPage';
import Contact from './pages/Contact';
import AboutUs from './pages/AboutUs';
import FAQPage from './pages/FAQPage';
import SalesSystem from './pages/SalesSystem';
import CookiePolicy from './pages/CookiePolicy';
import KVKKForm from './pages/KVKKForm';
import ReportGeneratorPage from './pages/ReportGeneratorPage';
import ReportEditPage from './pages/ReportEditPage';

import ReportsPage from './pages/ReportsPage';
import StandaloneSenetPage from './pages/StandaloneSenetPage';
import StandaloneSenetListPage from './pages/StandaloneSenetListPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DealerApplicationsPage from './pages/DealerApplicationsPage';
import AdminAnalyticsPage from './pages/AdminAnalyticsPage'; 
import AdminCreditCalculationPage from './pages/AdminCreditCalculationPage';
import AdminBankCreditManagementPage from './pages/AdminBankCreditManagementPage';
import SenetTakipPage from './pages/SenetTakipPage';



// Context
import { AuthProvider, useAuth } from './context/AuthContext';

import AdminUserManagementPage from './pages/AdminUserManagementPage';
import AdminApplicationsPage from './pages/AdminApplicationsPage';

import AdminBrandManagement from './pages/AdminBrandManagement';
import AdminLogDashboard from './pages/AdminLogDashboard';


import BlogPage from './pages/BlogPage';
import BlogDetailPage from './pages/BlogDetailPage';
import CreateBlogPage from './pages/CreateBlogPage';
import EditBlogPage from './pages/EditBlogPage';
import MyBlogsPage from './pages/MyBlogsPage';
import AdminEmployeeManagement from './pages/AdminEmployeeManagement';



// Korumalı Route bileşeni
const ProtectedRoute = ({ children }) => {
    const { currentUser, loading } = useAuth();
    if (loading) return <div>Yükleniyor...</div>;
    if (!currentUser) {
        return <Navigate to="/login" />;
    }
    return children;
};

// Admin Route için ProtectedAdminRoute component'i ekleyin (Routes'dan önce):
const ProtectedAdminRoute = ({ children }) => {
    const { currentUser, loading } = useAuth();
    if (loading) return <div>Yükleniyor...</div>;
    if (!currentUser) {
        return <Navigate to="/login" />;
    }
    if (currentUser.userType !== 'admin') {
        return <Navigate to="/" />;
    }
    return children;
};

// Admin veya Representative Route
const ProtectedAdminOrRepRoute = ({ children }) => {
    const { currentUser, loading } = useAuth();
    if (loading) return <div>Yükleniyor...</div>;
    if (!currentUser) {
        return <Navigate to="/login" />;
    }
    if (!['admin', 'representative'].includes(currentUser.userType)) {
        return <Navigate to="/" />;
    }
    return children;
};

// Admin, Representative veya Marketing Route
const ProtectedAdminRepOrMarketingRoute = ({ children }) => {
    const { currentUser, loading } = useAuth();
    if (loading) return <div>Yükleniyor...</div>;
    if (!currentUser) {
        return <Navigate to="/login" />;
    }
    if (!['admin', 'representative', 'marketing'].includes(currentUser.userType)) {
        return <Navigate to="/" />;
    }
    return children;
};

function App() {
    return (
        <AuthProvider>
            <Router>
                <ScrollToTop />
                <div className="App">
                    <Header />
                    <main>
                        <Routes>
                            {/* Ana rotalar */}
                            <Route path="/" element={<HomePage />} />
                            <Route path="/login" element={<LoginPage />} />
                            {/* /register route REMOVED - Admin will create users */}
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/about" element={<AboutUs />} />
                            <Route path="/faq" element={<FAQPage />} />
                            <Route path="/sales-system" element={<SalesSystem />} />

                            {/* forgot password */}
                            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                            <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

                            {/* Politika sayfaları */}
                            <Route path="/cerez-politikasi" element={<CookiePolicy />} />
                            <Route path="/kvkk-aydinlatma-formu" element={<KVKKForm />} />

                            {/* Admin rota */}
                            <Route path="/admin/import-vehicle-data" element={<AdminImportDataPage />} />

                            {/* Araç listeleme - PUBLIC */}
                            <Route path="/vehicles" element={<VehiclesPage />} />

                            {/* Başvuru sayfası */}
                            <Route path="/application" element={<ApplicationPage />} />
                            <Route path="/apply" element={<ApplicationPage />} />

                            {/* ARAÇ EKLEME - SPESİFİK ROUTE ÖNCE OLMALI */}
                            <Route path="/vehicles/add" element={
                                <ProtectedRoute>
                                    <AddVehiclePage />
                                </ProtectedRoute>
                            } />

                            {/* ARAÇ DETAY - DİNAMİK ROUTE SONRA */}
                            <Route path="/vehicles/:id" element={<VehicleDetailPage />} />

                            {/* Araç detay sayfası - Normal ve sayısal ID desteği */}
                            <Route path="/vehicles/:id" element={<VehicleDetailPage />} />

                            {/* Sayısal ID için alternatif rotalar */}
                            <Route path="/vehicle/:customId" element={<VehicleDetailPage />} />

                            {/* Korumalı rotalar - NORMAL KULLANICILAR */}
                            <Route path="/add-vehicle" element={
                                <ProtectedRoute>
                                    <AddVehiclePage />
                                </ProtectedRoute>
                            } />

                            {/* Rapor rotaları - NORMAL KULLANICILAR */}
                            <Route path="/report-generator" element={
                                <ProtectedRoute>
                                    <ReportGeneratorPage />
                                </ProtectedRoute>
                            } />

                            <Route path="/report-edit/:id" element={<ReportEditPage />} />


                            <Route path="/reports" element={
                                <ProtectedRoute>
                                    <ReportsPage />
                                </ProtectedRoute>
                            } />


                            <Route path="/standalone-senet" element={
                                <ProtectedAdminOrRepRoute>
                                    <StandaloneSenetPage />
                                </ProtectedAdminOrRepRoute>
                            } />
                            {/* ✅ GÜNCELLEME: Marketing rolü eklendi */}
                            <Route path="/standalone-senets" element={
                                <ProtectedAdminRepOrMarketingRoute>
                                    <StandaloneSenetListPage />
                                </ProtectedAdminRepOrMarketingRoute>
                            } />


                            {/* Araç düzenleme rotaları */}
                            <Route path="/vehicles/edit/:id" element={
                                <ProtectedRoute>
                                    <EditVehiclePage />
                                </ProtectedRoute>
                            } />
                            <Route path="/edit-vehicle/:id" element={
                                <ProtectedRoute>
                                    <EditVehiclePage />
                                </ProtectedRoute>
                            } />
                            <Route path="/vehicle/edit/:customId" element={
                                <ProtectedRoute>
                                    <EditVehiclePage />
                                </ProtectedRoute>
                            } />

                       

                            {/* Profil sayfası rotaları */}
                            <Route path="/profile" element={
                                <ProtectedRoute>
                                    <ProfilePage />
                                </ProtectedRoute>
                            } />
                            <Route path="/profile/edit" element={
                                <ProtectedRoute>
                                    <ProfileEditPage />
                                </ProtectedRoute>
                            } />

                            {/* Dealer rotaları */}
                            <Route path="/dealer/applications" element={
                                <ProtectedRoute>
                                    <DealerApplicationsPage />
                                </ProtectedRoute>
                            } />

                            {/* ========== ADMIN & and some representative ROuTeLARI ========== */}

                            {/*  Admin Analytics Dashboard */}
                            <Route path="/admin/analytics" element={
                                <ProtectedAdminRoute>
                                    <AdminAnalyticsPage />
                                </ProtectedAdminRoute>
                            } />

                            {/* ✅ GÜNCELLEME: Marketing rolü eklendi */}
                            {/*  Kredi Hesaplama */}
                            <Route path="/admin/credit-calculation" element={
                                <ProtectedAdminRepOrMarketingRoute>
                                    <AdminCreditCalculationPage />
                                </ProtectedAdminRepOrMarketingRoute>
                            } />

                            {/*  Kredi Yönetim Hesaplama */}
                            <Route path="/admin/bank-credit-management" element={
                                <ProtectedAdminRoute>
                                    <AdminBankCreditManagementPage />
                                </ProtectedAdminRoute>
                            } />

                            {/*  Senet Takip */}
                            <Route path="/admin/senet-takip" element={
                                <ProtectedAdminOrRepRoute>
                                    <SenetTakipPage />
                                </ProtectedAdminOrRepRoute>
                            } />

                            {/* ✅ GÜNCELLEME: Marketing rolü eklendi */}
                            {/* Başvuru Yönetimi */}
                            <Route path="/admin/applications" element={
                                <ProtectedAdminRepOrMarketingRoute>
                                    <AdminApplicationsPage />
                                </ProtectedAdminRepOrMarketingRoute>
                            } />

                            {/* Kullanıcı Yönetimi */}
                            <Route path="/admin/user-management" element={
                                <ProtectedAdminRoute>
                                    <AdminUserManagementPage />
                                </ProtectedAdminRoute>
                            } />

                            {/* ✅ GÜNCELLEME: Marketing rolü eklendi */}
                            {/* Rapor Yönetimi */}
                            <Route path="/admin/reports" element={
                                <ProtectedAdminRepOrMarketingRoute>
                                    <ReportsPage />
                                </ProtectedAdminRepOrMarketingRoute>
                            } />

                            <Route path="/admin/report-generator" element={
                                <ProtectedAdminOrRepRoute>
                                    <ReportGeneratorPage />
                                </ProtectedAdminOrRepRoute>
                            } />

                            {/* Araç Yönetimi */}
                            <Route path="/admin/vehicles" element={
                                <ProtectedAdminOrRepRoute>
                                    <VehiclesPage />
                                </ProtectedAdminOrRepRoute>
                            } />

                            <Route path="/admin/add-vehicle" element={
                                <ProtectedAdminOrRepRoute>
                                    <AddVehiclePage />
                                </ProtectedAdminOrRepRoute>
                            } />

                            <Route path="/admin/brand-management" element={
                                <ProtectedAdminOrRepRoute>
                                    <AdminBrandManagement />
                                </ProtectedAdminOrRepRoute>
                            } />

                            <Route path="/admin/logs" element={
                                <ProtectedAdminRoute>
                                    <AdminLogDashboard />
                                </ProtectedAdminRoute>
                            } />

                            {/* 🆕 YENİ ROUTE - BURAYA EKLE */}
                            <Route path="/admin/employee-management" element={
                                <ProtectedAdminRoute>
                                    <AdminEmployeeManagement />
                                </ProtectedAdminRoute>
                            } />

                            {/* Bulunamayan sayfalar için ana sayfaya yönlendirme */}
                            <Route path="*" element={<Navigate to="/" replace />} />

                            {/* Blog routes (public) */}
                            <Route path="/blog" element={<BlogPage />} />
                            <Route path="/blog/:slug" element={<BlogDetailPage />} />

                            {/* Admin blog routes */}
                            <Route path="/admin/my-blogs" element={
                                <ProtectedRoute>
                                    <MyBlogsPage />
                                </ProtectedRoute>
                            } />

                            {/* Representative blog routes */}
                            <Route path="/representative/my-blogs" element={
                                <ProtectedRoute>
                                    <MyBlogsPage />
                                </ProtectedRoute>
                            } />

                            <Route path="/admin/create-blog" element={
                                <ProtectedRoute>
                                    <CreateBlogPage />
                                </ProtectedRoute>
                            } />

                            {/* Blog edit route */}
                            <Route path="/admin/edit-blog/:id" element={
                                <ProtectedRoute>
                                    <EditBlogPage />
                                </ProtectedRoute>
                            } />

                        </Routes>
                    </main>
                    <Footer />
                </div>
            </Router>
        </AuthProvider>
    );
}

export default App;
